<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For<br/>My Mother,<br/>Barbara Jean.<br/>Few men will ever know such love and faith.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?fb05ee48